import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, BookOpenIcon, BarChart3Icon, LifeBuoyIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 bg-white overflow-hidden" data-id="element-250">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-251">
        {/* Solution Header */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-252">
          <span className="text-[#1B3A5C] font-bold tracking-wider uppercase text-sm" data-id="element-253">
            La Solución Clínica
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-2 mb-4" data-id="element-254">
            MEGA PACK DE INTERVENCIÓN FONOAUDIOLÓGICA INFANTIL™
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8" data-id="element-255">
            Un sistema completo de intervención de 6 meses, diseñado para la
            realidad del consultorio.
          </p>
          <div className="bg-blue-50 inline-block px-6 py-3 rounded-lg border border-blue-100" data-id="element-256">
            <p className="font-medium text-blue-900" data-id="element-257">
              No te dice qué pensar. No reemplaza tu criterio.{' '}
              <span className="font-bold" data-id="element-258">
                👉 Te da una estructura para trabajar con seguridad.
              </span>
            </p>
          </div>
        </motion.div>

        {/* System Details Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-259">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#EDF2F7] p-8 rounded-xl border border-blue-100 hover:shadow-lg transition-shadow" data-id="element-260">
            <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-sm mb-6" data-id="element-261">
              <BookOpenIcon className="w-6 h-6 text-[#C9A84C]" data-id="element-262" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-263">
              📘 24 SESIONES LISTAS PARA APLICAR
            </h3>
            <p className="text-sm text-gray-500 mb-4 uppercase tracking-wide font-semibold" data-id="element-264">
              Cada sesión incluye:
            </p>
            <ul className="space-y-2" data-id="element-265">
              {['Objetivo clínico claro', '3 actividades autocontenidas', 'Registro clínico', 'Tarea para casa', 'Adaptaciones para TEA, TDAH y ansiedad'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-266">
                  <CheckIcon className="w-4 h-4 text-[#1B3A5C] mt-0.5 flex-shrink-0" data-id="element-267" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-6 font-bold text-[#1B3A5C] text-sm" data-id="element-268">
              Nada suelto. Nada al azar.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#EDF2F7] p-8 rounded-xl border border-blue-100 hover:shadow-lg transition-shadow" data-id="element-269">
            <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-sm mb-6" data-id="element-270">
              <BarChart3Icon className="w-6 h-6 text-[#C9A84C]" data-id="element-271" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-272">
              📊 SEGUIMIENTO QUE SE VE
            </h3>
            <p className="text-sm text-gray-500 mb-4 uppercase tracking-wide font-semibold" data-id="element-273">
              Planillas organizadas por etapas:
            </p>
            <ul className="space-y-2 mb-4" data-id="element-274">
              {['Instalación', 'Consolidación', 'Generalización', 'Alta funcional'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-275">
                  <CheckIcon className="w-4 h-4 text-[#1B3A5C] mt-0.5 flex-shrink-0" data-id="element-276" />
                  {item}
                </li>)}
            </ul>
            <p className="text-sm text-gray-700 mb-4" data-id="element-277">
              Cada Ficha 5 de registro incluye una tabla de observación clínica,
              las áreas trabajadas en esa sesión y una tarea para casa concreta
              para que la familia refuerce lo trabajado.
            </p>
            <p className="font-bold text-[#1B3A5C] text-sm mb-2" data-id="element-278">
              👉 Pasás de "hacer sesiones" a mostrar proceso.
            </p>
            <p className="text-sm text-gray-700" data-id="element-279">
              La familia no solo escucha "estamos trabajando bien". Ve
              exactamente qué se trabajó, cómo evolucionó y qué puede hacer en
              casa para acompañar.
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-[#EDF2F7] p-8 rounded-xl border border-blue-100 hover:shadow-lg transition-shadow" data-id="element-280">
            <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-sm mb-6" data-id="element-281">
              <LifeBuoyIcon className="w-6 h-6 text-[#C9A84C]" data-id="element-282" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-283">
              🧠 SOPORTE CLÍNICO REAL
            </h3>
            <ul className="space-y-2 mb-6" data-id="element-284">
              {['Guía de uso del sistema', 'Criterios de adaptación por perfil', 'Organización del caso clínico', 'Manejo de situaciones difíciles en sesión'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-285">
                  <CheckIcon className="w-4 h-4 text-[#1B3A5C] mt-0.5 flex-shrink-0" data-id="element-286" />
                  {item}
                </li>)}
            </ul>
            <div className="bg-white p-4 rounded-lg border border-gray-100" data-id="element-287">
              <p className="text-xs font-bold text-gray-500 mb-2 uppercase" data-id="element-288">
                Pensado para cuando:
              </p>
              <ul className="space-y-1 text-sm text-gray-600" data-id="element-289">
                <li data-id="element-290">• La sesión no fluye</li>
                <li data-id="element-291">• El niño se desregula</li>
                <li data-id="element-292">• Vos necesitás sostén profesional</li>
              </ul>
            </div>
          </motion.div>
        </div>

        {/* What Changes Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#1B3A5C] rounded-2xl p-8 md:p-12 text-white" data-id="element-293">
          <h3 className="text-2xl md:text-3xl font-bold text-center mb-10" data-id="element-294">
            ¿QUÉ CAMBIA CUANDO TRABAJÁS ASÍ?
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-295">
            <div className="relative" data-id="element-296">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#C9A84C] rounded-full" data-id="element-297" />
              <div className="pl-6" data-id="element-298">
                <h4 className="text-xl font-bold mb-4 text-[#C9A84C]" data-id="element-299">
                  En sesión:
                </h4>
                <ul className="space-y-3" data-id="element-300">
                  {['Llegás con todo preparado para los tres perfiles que atendés', 'Sabés exactamente qué objetivo clínico estás trabajando', 'Tenés la adaptación para TDAH y TEA dentro de la misma ficha', 'Podés redirigir sin improvisar'].map((item, i) => <li key={i} className="flex items-start gap-2 text-base lg:text-lg" data-id="element-301">
                      <CheckIcon className="w-5 h-5 text-[#C9A84C] mt-1 flex-shrink-0" data-id="element-302" />
                      <span data-id="element-303">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            <div className="relative" data-id="element-304">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#C9A84C] rounded-full" data-id="element-305" />
              <div className="pl-6" data-id="element-306">
                <h4 className="text-xl font-bold mb-4 text-[#C9A84C]" data-id="element-307">
                  Fuera de sesión:
                </h4>
                <ul className="space-y-3" data-id="element-308">
                  {['Menos tiempo de planificación', 'Menos carga mental entre turno y turno', 'Registros claros para mostrar a las familias', 'Criterio profesional sostenido por estructura'].map((item, i) => <li key={i} className="flex items-start gap-2 text-base lg:text-lg" data-id="element-309">
                      <CheckIcon className="w-5 h-5 text-[#C9A84C] mt-1 flex-shrink-0" data-id="element-310" />
                      <span data-id="element-311">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            <div className="relative" data-id="element-312">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#C9A84C] rounded-full" data-id="element-313" />
              <div className="pl-6" data-id="element-314">
                <h4 className="text-xl font-bold mb-4 text-[#C9A84C]" data-id="element-315">
                  Con las familias:
                </h4>
                <ul className="space-y-3" data-id="element-316">
                  {['Podés explicar el proceso con documentación real', 'La ficha de registro les llega con el lenguaje justo', 'El avance se hace visible, no solo se cuenta'].map((item, i) => <li key={i} className="flex items-start gap-2 text-base lg:text-lg" data-id="element-317">
                      <CheckIcon className="w-5 h-5 text-[#C9A84C] mt-1 flex-shrink-0" data-id="element-318" />
                      <span data-id="element-319">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}